var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "sidebar"
    },
    [
      _c(
        "div",
        {
          staticClass: "transparent navigation navigation--v2"
        },
        [
          _c("app-logo", {
            staticClass: "mb-5 pl-4"
          }),
          _c(
            "v-list",
            {
              ref: "scrollbar",
              staticClass: "ps-sidebar",
              attrs: {
                expand: ""
              }
            },
            [
              _vm._l(_vm.visible_menu, function(item) {
                return [
                  item.items
                    ? [
                        _c(
                          "v-list-group",
                          {
                            key: item.title,
                            attrs: {
                              ripple: false,
                              "prepend-icon": "",
                              "no-action": "",
                              "append-icon": "",
                              group: item.group
                            },
                            model: {
                              value: item.active,
                              callback: function callback($$v) {
                                _vm.$set(item, "active", $$v)
                              },
                              expression: "item.active"
                            }
                          },
                          [
                            _c(
                              "v-list-item",
                              {
                                staticClass: "my-2 menu-parent",
                                attrs: {
                                  slot: "activator",
                                  ripple: false,
                                  "active-class": "navigation-active"
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.delayedNavigateTo(
                                      item.items[0].to
                                    )
                                  }
                                },
                                slot: "activator"
                              },
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      [
                                        item.action
                                          ? _c("v-icon", [
                                              _vm._v(
                                                " " + _vm._s(item.action) + " "
                                              )
                                            ])
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              item.active
                                                ? "font-weight-bold"
                                                : "font-weight-medium",
                                              "fs-14"
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.textTruncate(item.title)
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-action",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          small: ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.active
                                              ? "mdi-chevron-down"
                                              : "mdi-chevron-right"
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._l(
                              item.items.filter(function(i) {
                                return !i.hidden
                              }),
                              function(subItem) {
                                return [
                                  !subItem.external
                                    ? _c(
                                        "v-list-item",
                                        {
                                          key: subItem.title,
                                          attrs: {
                                            exact: subItem.exact,
                                            "active-class": "navigation-active",
                                            to: subItem.to,
                                            ripple: false
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass: "fs-14"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.textTruncate(
                                                          subItem.title
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-list-item",
                                        {
                                          key: subItem.title + "-ext",
                                          attrs: {
                                            exact: subItem.exact,
                                            ripple: false,
                                            href: subItem.to,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass: "fs-14"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.textTruncate(
                                                          subItem.title
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: ""
                                                  }
                                                },
                                                [_vm._v("mdi-open-in-new")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                ]
                              }
                            )
                          ],
                          2
                        )
                      ]
                    : [
                        _c(
                          "v-list-item",
                          {
                            key: item.path,
                            staticClass: "my-2",
                            attrs: {
                              to: item.to,
                              exact: item.exact,
                              ripple: false
                            }
                          },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c(
                                  "v-list-item-title",
                                  [
                                    item.action
                                      ? _c("v-icon", [
                                          _vm._v(_vm._s(item.action))
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "fs-14 font-weight-medium"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.textTruncate(item.title)
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            item.icon
                              ? _c(
                                  "v-list-item-action",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          small: ""
                                        }
                                      },
                                      [_vm._v(" " + _vm._s(item.icon) + " ")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                ]
              })
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }